<template lang="html">
  <div class="box-wrap" :class="{ 'box-wrap-min': min }">
    <div class="name">{{ name }}</div>
    <div class="box">
      <img />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    min: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.box-wrap {
  width: 100%;
  height: 100%;
  // background: url("../../../../../../assets/img/common/ljcborder.png");
  background-size: 100% 100%;
}

.box-wrap-min {
  width: 100%;
  height: 100%;
  // background: url("../../../../../../assets/img/common/ljcborder.png");
  background-size: 100% 100%;
}

.box {
  width: 100%;
  // margin-left: 0.5vh;vh
}
.name {
  font-size: 2vh;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 1.6vh;
  padding-top: 1.3vh;

  &:before {
    display: block;
    content: "";
    width: 400/1080vw;
    height: 1.6vh;
    background: rgba(0, 255, 253, 1);
    float: left;
    margin-left: 1.3vh;
    margin-right: 1vh;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?68c248ae